import { render, staticRenderFns } from "./Carrello2.vue?vue&type=template&id=54c669f4&"
import script from "./Carrello2.vue?vue&type=script&lang=js&"
export * from "./Carrello2.vue?vue&type=script&lang=js&"
import style0 from "./Carrello2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports